import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { EventService } from '../../event/event.service';
import { PresendJobIdentificationRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/job-identification-remote-action-builder/presend-job-identification-remoteaction-builder';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { GenericRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { DriverPassengerRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/driver-passenger-identification-remote-action-builder/driver-passenger-identification-remoteaction-builder';
import { JobIdentificationRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/job-identification-remote-action-builder/job-identification-remoteaction-builder';

@Injectable({
  providedIn: 'root',
})
export class JobIdentificationActionHandler
  implements ActionHandler
{
  // Public Member
  public readonly name: ActionHandlerType = 'jobidentification';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private employeeService: EmployeeService,
    private locationService: LocationService,
    private appParameterService: AppParameterService,
    private eventService: EventService,
    private serviceJobsService: ServicejobsService,
    private remoteActionService: RemoteActionService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    console.log("JBBWS jobidentification called")

    let presendTestRab = new PresendJobIdentificationRemoteActionBuilder(
      this.appService,
      this.credentialsService,
      this.clientStateService,
      this.serviceJobsService,
      this.locationService,
      this.logger
    );
    var startTimeStamp: string;

    try {
      let presendTestRa = await presendTestRab.generateRemoteAction([]);
      const result = await this.remoteActionService.sendRemoteAction(presendTestRa);

      startTimeStamp = result?.starttstamp ?? "not_found"
    } catch (_) {
      startTimeStamp = "not_found"
    }

    try {

      const rab: GenericRemoteActionBuilder =
      new JobIdentificationRemoteActionBuilder(
        this.clientStateService,
        this.appService,
        this.credentialsService,
        this.employeeService,
        this.locationService,
        this.serviceJobsService,
        startTimeStamp,
        this.logger,
      );
      this.remoteActionBuilderService.newBuild(rab);
      this.zone.run(() => {
        this.navigationController.navigateForward('/feature/remote-action');
      });

    } catch (error) {
      this.logger.error(
        this.constructor.name,
        'JBBWS Error pretesting job identification: ',
        error?.message
      );
    }
   
  }
}
